import * as React from 'react'
import styled from 'styled-components'
import SimpleTooltip from '@/components/Tooltips/SimpleTooltip'

const Container = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 16px;
	background: #E4E7EB;
	position: relative;
	border-radius: 4px;
	overflow: hidden;
	border: 1px solid rgba(29,30,27,.25);
`

const Item = styled.div`
	height: 16px;
`

interface IReportProgressBarItem {
	value: number
	color: string
	tooltipLabel?: (percentage: number) => string
}

interface IProps {
	items?: IReportProgressBarItem[]
}

const ReportProgressbar = (props: IProps) => {
	const { items, } = props

	const totalValue = items.reduce((total, item) => total + item.value, 0)

	return (
		<Container>
			{items.map((item, index) => {
				const percentage = item.value / totalValue * 100
				const progressStyle = { width: `${percentage}%`, backgroundColor: item.color }
				return (
					<SimpleTooltip key={index} content={item.tooltipLabel ? item.tooltipLabel(percentage) : ''}>
						<Item
							style={progressStyle}
						/>
					</SimpleTooltip>
				)
			})}
		</Container>
	)
}

export default ReportProgressbar